@if (data.data; as contextualHelp) {
  <div class="info-dialog">
    @if (!data.hasCloseBtn) {
      <a tabindex="0" role="button" data-cy="context-help-close" (keyup.enter)="$event.target.click()" class="close-btn" (click)="closeDialog()" aria-label="Close">
        <span class="icon-shape"></span>
      </a>
    }
    <div class="info-header mb-4">
      <h1 class="title" data-cy="context-help-title">
        {{ contextualHelp.title }}
      </h1>
      <div class="title-desc" [innerHTML]="contextualHelp.description"></div>
    </div>
    @for (item of contextualHelp.contextualHelpItems; track item) {
      <div class="mb-4 row">
        <h2 class="col-12 subtitle text-uppercase" data-cy="context-help-comp">
          {{ item.fields.title }}
        </h2>
        @if (item.fields.clientTutorialVideo) {
          <a class="col-12 info-link" data-cy="app-more-info__contextual-help-video-link" role="button" tabindex="0" (click)="openVideo(item.fields)">Video</a>
        }
        @if (item.fields.clientDocumentation) {
          <a class="col-12 info-link" [href]="getUserGuideUrl(item.fields)" target="_blank">User Guide</a>
        }
      </div>
    }
  </div>
}
@if (data.hasCloseBtn) {
  <div class="content-footer text-right">
    <button mat-flat-button class="mat-secondary" id="btnClose" type="button" (click)="closeDialog()">Close</button>
  </div>
}
